import React from 'react'
import { generatePath, Link } from 'react-router-dom'
import { Space, Button } from 'antd'
import * as Icons from '@ant-design/icons'
import moment from 'moment'
import { CSVLink } from 'react-csv'

import { Queries } from 'admin/lib/Api'
import { Breadcrumb } from 'admin/lib/Breadcrumbs'
import { Layout } from 'admin/lib/Layouts'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import * as ROUTES from 'admin/routes'

import { AccountsList } from './AccountsList'

export function Accounts() {
  const userAccountMappings = Queries.useUserSelfAccountMappings()

  function calculateData(accounts) {
    const dataRows = [
      [
        'Account Name',
        'Account Id',
        'Company Name',
        'Renewal Date',
        'Project Name',
        'Project Id'
      ]
    ]
    accounts.forEach(account =>
      account.projects.forEach(project => {
        dataRows.push([
          account.name,
          account.accountId,
          account.companyName,
          account.renewalDate
            ? moment(account.renewalDate).format('YYYY-MM-DD')
            : '',
          project.name,
          project.projectId
        ])
      })
    )
    return dataRows
  }

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: 'Accounts'
              }
            ]}
          />

          <Space>
            {userAccountMappings.isFetched && userAccountMappings.data && (
              <CSVLink
                filename={'Accounts.csv'}
                data={calculateData(userAccountMappings.data)}
              >
                Download CSV
              </CSVLink>
            )}
            <Link to={generatePath(ROUTES.ACCOUNTS.NEW)}>
              <Button type="primary" icon={<Icons.FormOutlined />}>
                New
              </Button>
            </Link>
          </Space>
        </>
      }
    >
      {!userAccountMappings.isFetched && <ScreenSpin />}

      {userAccountMappings.isError && (
        <div>
          Something went wrong:{' '}
          {String(
            userAccountMappings.error.response?.data ??
              userAccountMappings.error
          )}
        </div>
      )}

      {userAccountMappings.isFetched && userAccountMappings.data && (
        <AccountsList userAccountMappings={userAccountMappings.data} />
      )}
    </Layout>
  )
}
